import { render, staticRenderFns } from "./FollowupsViewChips.vue?vue&type=template&id=0b925410&scoped=true"
import script from "./FollowupsViewChips.vue?vue&type=script&lang=js"
export * from "./FollowupsViewChips.vue?vue&type=script&lang=js"
import style0 from "./FollowupsViewChips.vue?vue&type=style&index=0&id=0b925410&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b925410",
  null
  
)

export default component.exports